<template>
    <div>
        <b-row>
            <b-col sm="12" md="3" lg="2">
                <b-form-group>
                    <label class="required">CEP</label>
                    <b-input-group>
                        <b-form-input
                            maxlength="9"
                            type="text"
                            v-model="cep"
                            @keypress.native.enter="pesquisarCep()"
                            :state="$v.cep.$error && mostrarMsgErro ? false : null"
                            @input="$v.cep.$touch()"
                            :disabled="disabled"
                            v-mask="'#####-###'"
                        ></b-form-input>
                        <b-input-group-append>
                            <b-input-group-text v-if="processandoCep">
                                <i class="fa fa-circle-o-notch fa-spin"></i>
                            </b-input-group-text>
                            <b-button
                                v-if="!processandoCep"
                                variant="primary"
                                @click="pesquisarCep()"
                                title="Clique para pesquisar o CEP"
                                :disabled="disabled"
                            >
                                <i class="fa fa-search"></i>
                            </b-button>
                        </b-input-group-append>
                        <b-form-invalid-feedback>O CEP é obrigatório</b-form-invalid-feedback>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col sm="12" md="5">
                <b-form-group>
                    <label class="required">Logradouro</label>
                    <b-form-input
                        type="text"
                        v-model="logradouro"
                        @input="$v.logradouro.$touch()"
                        :state="$v.logradouro.$error && mostrarMsgErro ? false : null"
                        :disabled="disabled"
                    ></b-form-input>
                    <b-form-invalid-feedback>O logradouro é obrigatório</b-form-invalid-feedback>
                </b-form-group>
            </b-col>
            <b-col sm="12" md="2">
                <b-form-group>
                    <label class="required">Número</label>
                    <b-form-input
                        ref="numero"
                        type="text"
                        v-model="numero"
                        @input="$v.numero.$touch()"
                        :state="$v.numero.$error && mostrarMsgErro ? false : null"
                        :disabled="disabled"
                    ></b-form-input>
                    <b-form-invalid-feedback>O número é obrigatório</b-form-invalid-feedback>
                </b-form-group>
            </b-col>
            <b-col sm="12" md="2" lg="3">
                <b-form-group>
                    <label>Complemento</label>
                    <b-form-input
                        type="text"
                        id="complemento"
                        v-model="complemento"
                        :disabled="disabled"
                    ></b-form-input>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="12" md="5">
                <b-form-group>
                    <label class="required">Bairro</label>
                    <b-form-input
                        type="text"
                        v-model="bairro"
                        @input="$v.bairro.$touch()"
                        :state="$v.bairro.$error && mostrarMsgErro ? false : null"
                        :disabled="disabled"
                    ></b-form-input>
                    <b-form-invalid-feedback>O bairro é obrigatório</b-form-invalid-feedback>
                </b-form-group>
            </b-col>
            <b-col sm="12" md="5">
                <b-form-group>
                    <label class="required">Cidade</label>
                    <b-form-input
                        type="text"
                        v-model="cidade"
                        @input="$v.cidade.$touch()"
                        :state="$v.cidade.$error && mostrarMsgErro ? false : null"
                        :disabled="disabled"
                    ></b-form-input>
                    <b-form-invalid-feedback>A cidade é obrigatória</b-form-invalid-feedback>
                </b-form-group>
            </b-col>
            <b-col sm="12" md="2">
                <b-form-group>
                    <label>UF</label>
                    <b-form-select
                        id="uf"
                        :plain="true"
                        :options="estados"
                        v-model="uf"
                        :disabled="disabled"
                    ></b-form-select>
                </b-form-group>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import axios from 'axios'
import { estados2 } from './../consts/estados'
import { required, minLength } from 'vuelidate/lib/validators'

export default {
	name: 'app-endereco-form',
	data() {
		return {
			processandoCep: false,
			logradouro: '',
			numero: '',
			complemento: '',
			bairro: '',
			cidade: '',
			uf: 'PE',
			cep: '',
			estados: estados2
		}
	},
	props: {
		value: {
			type: Object
		},
		disabled: {
			type: Boolean
		},
		mostrarMsgErro: {
			required: false,
			default: true
		}
	},
	watch: {
		logradouro() {
			this.atualizarEndereco()
		},
		numero() {
			this.atualizarEndereco()
		},
		complemento() {
			this.atualizarEndereco()
		},
		bairro() {
			this.atualizarEndereco()
		},
		cidade() {
			this.atualizarEndereco()
		},
		uf() {
			this.atualizarEndereco()
		},
		cep() {
			this.atualizarEndereco()
		},
		value() {
			this.carregaEndereco()
		}
	},
	methods: {
		atualizarEndereco() {
			let endereco = {
				logradouro: this.logradouro,
				numero: this.numero,
				complemento: this.complemento,
				bairro: this.bairro,
				cidade: this.cidade,
				uf: this.uf,
				cep: this.cep.apenasNumeros(),
				valido: !this.$v.$invalid
			}
			this.$emit('input', endereco)
		},

		pesquisarCep() {
			if (this.cep.apenasNumeros().length === 8) {
				this.processandoCep = true
				let promisse = axios.get(
					`https://viacep.com.br/ws/${this.cep.apenasNumeros()}/json/`
				)
				promisse
					.then(response => {
						if (response.data.erro) {
							console.log('CEP não localizado')
							this.processandoCep = false
						} else {
							this.logradouro = response.data.logradouro.toUpperCase()
							this.bairro = response.data.bairro.toUpperCase()
							this.cidade = response.data.localidade.toUpperCase()
							this.uf = response.data.uf
							this.processandoCep = false
							this.$refs.numero.focus()
						}
					})
					.catch(response => {
						console.log(response)
						this.processandoCep = false
					})
			}
		},

		carregaEndereco() {
			if (this.value) {
				this.logradouro = this.value.logradouro
				this.numero = this.value.numero
				this.complemento = this.value.complemento
				this.bairro = this.value.bairro
				this.cidade = this.value.cidade
				if (this.value.uf) {
					this.uf = this.value.uf
				} else {
					this.uf = 'PE'
				}
				this.cep = this.$mask(this.value.cep, '#####-###')
			} else {
				this.uf = 'PE'
			}
		}
	},

	validations: {
		logradouro: {
			required
		},
		cep: {
			required,
			minLength: minLength(9)
		},
		numero: {
			required
		},
		bairro: {
			required
		},
		cidade: {
			required
		}
	}
}
</script>
